import { TenantActionableCase } from '@digitale-verhuurders-verklaring/core/src/models/shared/dynamoDB/declarationSchemas';
import { JsonSuccessResponse } from '@digitale-verhuurders-verklaring/core/src/models/shared/types';

import { useAxiosClient } from '../utils/useAxiosClient';

export const getOldestActionableCaseForTenant =
  async (): Promise<TenantActionableCase> => {
    const client = await useAxiosClient();
    return client
      .get<JsonSuccessResponse<TenantActionableCase>>(
        '/handlers/getOldestActionableStepForTenant',
      )
      .then((res) => res.data.data)
      .catch((error: unknown) => {
        throw error;
      });
  };
